import { ArrowLeft, HelpCircle } from 'lucide-react'
import {Link} from "react-router-dom"
import Image from "next/image"

interface CurriculumHeaderProps {
  courseTitle: string
  lessonTitle: string
}

export function CurriculumHeader({ courseTitle, lessonTitle }: CurriculumHeaderProps) {
  return (
    <header className="sticky top-0 z-20 flex w-full flex-col text-gray-800 items-center bg-transparent backdrop-blur-sm">
      <div className="flex w-full max-w-[1440px] items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        {/* Left side - Back and logo */}
        <div className="flex items-center gap-2">
          <Link to="/career-learning-path">
            <button className="flex h-10 w-10 items-center justify-center rounded-full hover:bg-gray-200 transition-colors">
              <ArrowLeft className="w-5 h-5" />
            </button>
          </Link>
          <div className="hidden items-center gap-2 sm:flex">
          </div>
        </div>

        {/* Center - Course title */}
        <div className="hidden sm:block text-lg font-bold">{courseTitle}</div>

        {/* Right side - Help and profile */}
        <div className="flex items-center gap-4">
          <button className="flex h-10 w-10 items-center justify-center rounded-full hover:bg-gray-200 transition-colors">
            <HelpCircle className="w-5 h-5" />
          </button>
        </div>
      </div>
    </header>
  )
}
